import React from 'react';
import { Carousel } from 'react-bootstrap';
import { HomePage } from '../HomePage/HomePage';
// import { CrazoHomepage } from '../../pages/CrazoHomepage';
import { StoreHomePage } from '../../pages/StoreHomePage';
import styles from './HomePageCarousel.module.scss';

import google_store_btn from '../../assets/imgs/btn_google_play_new.png';
import apple_store_btn from '../../assets/imgs/btn_apple_store_new.png';
import { SocialMediaLinks } from '../SocialMediaLinks/SocialMediaLinks';
import { AtariInvasionHomePage } from '../../pages/AtariInvasionHomePage';
const cdhGpLink = "https://go.onelink.me/bUzl/9c836b67";
const cdhAppStoreLink = "https://go.onelink.me/VHLW/e01c1c3f";

const HomePageCarousel = () => {
    const componentsToRender = [
        // {
        //     name: 'crazo-homepage',
        //     component: <CrazoHomepage />,
        //     timeInterval: 12000
        // },
        // {
        //     name: 'atari-invasion-homepage',
        //     component: <AtariInvasionHomePage />,
        //     timeInterval: 12000
        // },
        {
            name: 'store-homepage',
            component: <StoreHomePage />,
            timeInterval: 7000
        },
        {
            name: 'homepage',
            component: <HomePage />,
            timeInterval: 7000
        },
    ];

    const SliderStyles = `
        .carousel-indicators {
            padding-left: var(--sidebar-width);
        }

        .carousel-inner {
            height: 100vh;
        }

        @media (max-width: 992px) {
            .carousel-indicators {
                padding-left: 0;
                bottom: 200px;
            }

            .carousel-indicators:hover {
                display: none;
            }

            .carousel-indicators li {
                height: 8px !important;
                width: 8px !important;
                border-radius: 25px !important;
                border: initial !important;
            }

            .carousel-inner {
                height: calc(100vh - 70px);
            }
        }

        @media (max-width: 992px) and (max-height: 500px) {
            .carousel-indicators {
                bottom: 60px;
            }
        }
    `;

    return (
        <div className={styles.homepage_carousel_container}>
            <div className={styles.component_container}>
                <Carousel style={{ width: "100%" }} pause={false} controls={false}>
                    {componentsToRender.map((item) => (
                        <Carousel.Item interval={item.timeInterval} key={item.name}>
                            {item.component}
                        </Carousel.Item>
                    ))}
                </Carousel>

                <div className={styles.app_and_socials}>
                    <div className={styles.store_btns}>
                        <a href={cdhAppStoreLink} target="_blank" rel="noopener noreferrer" className={styles.app_store_btn}>
                            <img src={apple_store_btn} alt="apple-app-store" />
                        </a>
                        <a href={cdhGpLink} target="_blank" rel="noopener noreferrer" className={styles.app_store_btn}>
                            <img src={google_store_btn} alt="google-app-store" />
                        </a>
                    </div>

                    <div className={styles.mobile_social_links_container}>
                        <SocialMediaLinks />
                    </div>
                </div>
            </div>

            <style>
                {SliderStyles}
            </style>
        </div>
    )
}

export { HomePageCarousel }